<template>
    <div>
        <page-header :title="$t('master.terms')" />
        <p class="terms-and-conditions ion-padding-end">
<ul>
   <li v-for="(value, key) in  $t('terms.terms')"> {{ value }} </li>
 </ul>
</p>
    </div>
</template>

<script>
import PageHeader from '@/components/PageHeader'
import { isMobile } from 'mobile-device-detect'

export default {
    name: 'Terms',
    components: { PageHeader },
    data() {
        return {
            isMobile
        }
    },
}
</script>

<style lang="scss">
.terms-and-conditions {
    text-align: start;

    li {
        margin-top: 10px;
    }
}

@media (min-width: 768px) {
    .terms-and-conditions {
        font-size: 20px;
    }
}
</style>
